import React, { useState } from 'react';
import { PUZO_ADDRESS } from '../config/constants';

const About: React.FC = () => {
  const [copied, setCopied] = useState(false);
  const [addingToWallet, setAddingToWallet] = useState(false);

  // Твой GitHub URL для логотипа
  const PUZO_LOGO_URL = 'https://raw.githubusercontent.com/xasansheekhmaxamuud0-coder/Logo/main/puzo-logo.png';

  const copyToClipboard = async (text: string) => {
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (error) {
      const textArea = document.createElement('textarea');
      textArea.value = text;
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand('copy');
      document.body.removeChild(textArea);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }
  };

  const addToWallet = async () => {
    if (typeof window.ethereum === 'undefined') {
      alert('Please install MetaMask!');
      return;
    }

    setAddingToWallet(true);

    try {
      // Правильный формат для wallet_watchAsset
      await window.ethereum.request({
        method: 'wallet_watchAsset',
        params: {
          type: 'ERC20', // type должен быть на верхнем уровне params
          options: {
            address: PUZO_ADDRESS,
            symbol: 'PUZO',
            decimals: 18,
            image: PUZO_LOGO_URL,
          },
        },
      } as any); // Используем any чтобы обойти проверку TypeScript
    } catch (error) {
      console.error('Error adding token to wallet:', error);
      alert('Failed to add token to wallet. Please try manual method.');
    } finally {
      setAddingToWallet(false);
    }
  };

  return (
    <div>
      <div className="interface-panel">
        <div className="panel-header">
          <div className="panel-title">Protocol Information</div>
        </div>
        <div className="panel-content">
          <div className="system-alert">
            <div className="text-primary" style={{marginBottom: '12px', fontSize: '0.8rem'}}>PROOF OF USEFUL WORK</div>
            <div style={{fontSize: '0.75rem', lineHeight: '1.5', color: '#ccc'}}>
              Advanced consensus mechanism where miners search for cryptographic keys in specific ranges. 
              Each valid range discovered equals one PUZO token reward.
            </div>
          </div>

          <div className="quantum-stats">
            <div className="quantum-stat">
              <div className="stat-label">Consensus</div>
              <div className="stat-value">PoUW</div>
            </div>
            <div className="quantum-stat">
              <div className="stat-label">Mining</div>
              <div className="stat-value">Key Range</div>
            </div>
            <div className="quantum-stat">
              <div className="stat-label">Reward</div>
              <div className="stat-value">1 Range = 1 PUZO</div>
            </div>
            <div className="quantum-stat">
              <div className="stat-label">Platform</div>
              <div className="stat-value">puzbit.org</div>
            </div>
          </div>

          <div style={{fontSize: '0.75rem', lineHeight: '1.6', color: '#888'}}>
            <div style={{marginBottom: '16px'}}>
              The PoUW mining protocol represents the evolution of cryptographic computation - 
              transforming computational energy into meaningful cryptographic discovery.
            </div>
            <div>
              Each mining operation contributes to the security of the quantum-resistant cryptographic 
              landscape while generating value through PUZO token rewards at a rate of one token per validated range.
            </div>
          </div>
        </div>
      </div>

      <div className="interface-panel" style={{marginTop: '20px'}}>
        <div className="panel-header">
          <div className="panel-title">Token Contract</div>
        </div>
        <div className="panel-content">
          {/* Логотип токена */}
          <div style={{textAlign: 'center', marginBottom: '20px'}}>
            <img 
              src={PUZO_LOGO_URL} 
              alt="PUZO Token" 
              style={{
                width: '80px',
                height: '80px',
                borderRadius: '12px',
                objectFit: 'cover',
                border: '1px solid var(--border)'
              }}
              onError={(e) => {
                // Fallback если картинка не загрузится
                e.currentTarget.style.display = 'none';
              }}
            />
            <div style={{fontSize: '0.8rem', color: '#888', marginTop: '8px'}}>PUZO Token</div>
          </div>

          <div style={{marginBottom: '20px'}}>
            <div style={{fontSize: '0.7rem', color: '#888', marginBottom: '8px'}}>TOKEN ADDRESS</div>
            <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: '10px',
              background: 'rgba(10, 10, 15, 0.8)',
              border: '1px solid var(--border)',
              padding: '12px',
              borderRadius: '4px',
              fontSize: '0.75rem',
              wordBreak: 'break-all'
            }}>
              <span>{PUZO_ADDRESS}</span>
              <button 
                onClick={() => copyToClipboard(PUZO_ADDRESS)}
                style={{
                  background: copied ? 'var(--secondary)' : 'transparent',
                  border: copied ? '1px solid var(--secondary)' : '1px solid var(--primary)',
                  color: copied ? 'var(--background)' : 'var(--primary)',
                  padding: '6px 12px',
                  borderRadius: '4px',
                  fontSize: '0.7rem',
                  cursor: 'pointer',
                  flexShrink: 0,
                  transition: 'all 0.3s ease',
                  minWidth: '60px'
                }}
                onMouseOver={(e) => {
                  if (!copied) {
                    e.currentTarget.style.background = 'var(--primary)';
                    e.currentTarget.style.color = 'var(--background)';
                  }
                }}
                onMouseOut={(e) => {
                  if (!copied) {
                    e.currentTarget.style.background = 'transparent';
                    e.currentTarget.style.color = 'var(--primary)';
                  }
                }}
              >
                {copied ? 'COPIED!' : 'COPY'}
              </button>
            </div>
            {copied && (
              <div style={{
                fontSize: '0.7rem',
                color: 'var(--secondary)',
                textAlign: 'center',
                marginTop: '8px',
                animation: 'fadeIn 0.3s ease'
              }}>
                ✓ Address copied to clipboard
              </div>
            )}
          </div>

          {/* Кнопка автодобавления в кошелек */}
          <button 
            onClick={addToWallet}
            disabled={addingToWallet}
            style={{
              width: '100%',
              background: 'transparent',
              border: '1px solid var(--secondary)',
              color: 'var(--secondary)',
              padding: '12px',
              borderRadius: '4px',
              fontSize: '0.8rem',
              cursor: 'pointer',
              transition: 'all 0.3s ease',
              marginBottom: '16px'
            }}
            onMouseOver={(e) => {
              e.currentTarget.style.background = 'var(--secondary)';
              e.currentTarget.style.color = 'var(--background)';
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.background = 'transparent';
              e.currentTarget.style.color = 'var(--secondary)';
            }}
          >
            {addingToWallet ? (
              <>
                <span className="quantum-loading"></span>
                ADDING TO WALLET...
              </>
            ) : (
              '➕ ADD PUZO TO WALLET'
            )}
          </button>

          <div style={{fontSize: '0.75rem', color: '#888'}}>
            <div style={{marginBottom: '8px'}}><strong>Token Details:</strong></div>
            <div style={{marginBottom: '4px'}}>• Symbol: PUZO</div>
            <div style={{marginBottom: '4px'}}>• Decimals: 18</div>
            <div style={{marginBottom: '4px'}}>• Standard: BEP-20</div>
            <div>• Network: Binance Smart Chain</div>
          </div>
        </div>
      </div>

      <div className="interface-panel" style={{marginTop: '20px'}}>
        <div className="panel-header">
          <div className="panel-title">Manual Wallet Setup</div>
        </div>
        <div className="panel-content">
          <div style={{fontSize: '0.75rem', lineHeight: '1.6', color: '#888', marginBottom: '16px'}}>
            If auto-add doesn't work, follow these steps:
          </div>
          
          <div style={{display: 'grid', gap: '12px'}}>
            <div style={{display: 'flex', alignItems: 'flex-start', gap: '12px'}}>
              <div style={{
                width: '20px',
                height: '20px',
                background: 'var(--primary)',
                color: 'var(--background)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '0.7rem',
                flexShrink: 0
              }}>1</div>
              <div>
                <div style={{fontSize: '0.8rem', marginBottom: '4px'}}>Open Your Wallet</div>
                <div style={{fontSize: '0.75rem', color: '#888'}}>Open MetaMask or your preferred BSC wallet</div>
              </div>
            </div>
            
            <div style={{display: 'flex', alignItems: 'flex-start', gap: '12px'}}>
              <div style={{
                width: '20px',
                height: '20px',
                background: 'var(--primary)',
                color: 'var(--background)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '0.7rem',
                flexShrink: 0
              }}>2</div>
              <div>
                <div style={{fontSize: '0.8rem', marginBottom: '4px'}}>Import Token</div>
                <div style={{fontSize: '0.75rem', color: '#888'}}>Go to Assets → Import Tokens</div>
              </div>
            </div>
            
            <div style={{display: 'flex', alignItems: 'flex-start', gap: '12px'}}>
              <div style={{
                width: '20px',
                height: '20px',
                background: 'var(--primary)',
                color: 'var(--background)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '0.7rem',
                flexShrink: 0
              }}>3</div>
              <div>
                <div style={{fontSize: '0.8rem', marginBottom: '4px'}}>Enter Contract Details</div>
                <div style={{fontSize: '0.75rem', color: '#888'}}>
                  Address: {PUZO_ADDRESS.slice(0, 8)}...{PUZO_ADDRESS.slice(-6)}
                </div>
                <div style={{fontSize: '0.75rem', color: '#888'}}>Symbol: PUZO | Decimals: 18</div>
              </div>
            </div>
            
            <div style={{display: 'flex', alignItems: 'flex-start', gap: '12px'}}>
              <div style={{
                width: '20px',
                height: '20px',
                background: 'var(--primary)',
                color: 'var(--background)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '0.7rem',
                flexShrink: 0
              }}>4</div>
              <div>
                <div style={{fontSize: '0.8rem', marginBottom: '4px'}}>Confirm</div>
                <div style={{fontSize: '0.75rem', color: '#888'}}>Click "Add Custom Token" and confirm</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="interface-panel" style={{marginTop: '20px'}}>
        <div className="panel-header">
          <div className="panel-title">Mining Process</div>
        </div>
        <div className="panel-content">
          <div style={{display: 'grid', gap: '16px'}}>
            <div style={{display: 'flex', alignItems: 'flex-start', gap: '12px'}}>
              <div style={{
                width: '20px',
                height: '20px',
                background: 'var(--primary)',
                color: 'var(--background)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '0.7rem',
                flexShrink: 0
              }}>1</div>
              <div>
                <div style={{fontSize: '0.8rem', marginBottom: '4px'}}>Range Assignment</div>
                <div style={{fontSize: '0.75rem', color: '#888'}}>Miner receives specific cryptographic key range for search</div>
              </div>
            </div>
            
            <div style={{display: 'flex', alignItems: 'flex-start', gap: '12px'}}>
              <div style={{
                width: '20px',
                height: '20px',
                background: 'var(--primary)',
                color: 'var(--background)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '0.7rem',
                flexShrink: 0
              }}>2</div>
              <div>
                <div style={{fontSize: '0.8rem', marginBottom: '4px'}}>Key Discovery</div>
                <div style={{fontSize: '0.75rem', color: '#888'}}>Computational power searches for valid keys within assigned range</div>
              </div>
            </div>
            
            <div style={{display: 'flex', alignItems: 'flex-start', gap: '12px'}}>
              <div style={{
                width: '20px',
                height: '20px',
                background: 'var(--primary)',
                color: 'var(--background)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '0.7rem',
                flexShrink: 0
              }}>3</div>
              <div>
                <div style={{fontSize: '0.8rem', marginBottom: '4px'}}>Token Reward</div>
                <div style={{fontSize: '0.75rem', color: '#888'}}>Each validated range discovery rewards 1 PUZO token</div>
              </div>
            </div>
            
            <div style={{display: 'flex', alignItems: 'flex-start', gap: '12px'}}>
              <div style={{
                width: '20px',
                height: '20px',
                background: 'var(--primary)',
                color: 'var(--background)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '0.7rem',
                flexShrink: 0
              }}>4</div>
              <div>
                <div style={{fontSize: '0.8rem', marginBottom: '4px'}}>Liquidity Provision</div>
                <div style={{fontSize: '0.75rem', color: '#888'}}>Mined tokens available for trading on PuzoDEX</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
